module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-04.9df3a35d.png";